import { useEffect, useRef, useState } from 'react';
import { api, ApiError } from '../api/client.js';

export interface ChangePasswordDialogProps {
  open: boolean;
  /** Nach dem Zurücksetzen ist die Änderung Pflicht. */
  required?: boolean;
  onClose(): void;
  onChanged(): void;
}

/** Eigenes Passwort ändern (Vorgabe V5). */
export function ChangePasswordDialog({
  open,
  required,
  onClose,
  onChanged,
}: ChangePasswordDialogProps) {
  const dialog = useRef<HTMLDialogElement | null>(null);
  const [current, setCurrent] = useState('');
  const [next, setNext] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    const element = dialog.current;
    if (!element) return;
    if (open && !element.open) element.showModal();
    if (!open && element.open) element.close();
  }, [open]);

  const submit = async (event: React.FormEvent) => {
    event.preventDefault();
    setBusy(true);
    try {
      await api.changePassword(current, next);
      setCurrent('');
      setNext('');
      setError(null);
      onChanged();
      onClose();
    } catch (cause) {
      setError(cause instanceof ApiError ? cause.message : 'Ändern fehlgeschlagen.');
    } finally {
      setBusy(false);
    }
  };

  return (
    <dialog
      className="help-dialog"
      ref={dialog}
      aria-label="Passwort ändern"
      onCancel={(event) => {
        if (required) event.preventDefault();
      }}
      onClose={onClose}
    >
      <header>
        <h2>Passwort ändern</h2>
        {required ? null : (
          <button type="button" onClick={onClose} aria-label="Schließen">
            ×
          </button>
        )}
      </header>
      <form className="upload-body" onSubmit={submit}>
        {required ? (
          <p className="hint">
            Das Passwort wurde zurückgesetzt. Bitte jetzt ein eigenes Passwort vergeben.
          </p>
        ) : null}
        <label className="field">
          <span>Bisheriges Passwort</span>
          <input
            type="password"
            value={current}
            required
            autoComplete="current-password"
            onChange={(event) => setCurrent(event.target.value)}
          />
        </label>
        <label className="field">
          <span>Neues Passwort (mindestens 10 Zeichen)</span>
          <input
            type="password"
            value={next}
            required
            minLength={10}
            autoComplete="new-password"
            onChange={(event) => setNext(event.target.value)}
          />
        </label>
        {error ? (
          <p className="error" role="alert">
            {error}
          </p>
        ) : null}
        <div className="button-row">
          <button type="submit" disabled={busy}>
            {busy ? 'Bitte warten …' : 'Passwort ändern'}
          </button>
        </div>
      </form>
    </dialog>
  );
}
